<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="兑换商店配置" @back="goBack" /></span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:rewardExchangeStoreEdit:add']" type="primary" @click="beforeAddLevel()">添加等级</el-button>
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择类型">
                <el-select v-model="levelFormData.type" style="width: 150px" placeholder="请选择">
                  <el-option
                    v-for="item in conditionType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="数值">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel()">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="getLabelName(tabItem.label)">
            <template #label>
              <div>
                {{ getLabelName(tabItem.label) }}
              </div>
            </template>

            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="选择类型">
                  <el-select v-model="tabItem.type" style="width: 150px" placeholder="请选择" @change="(v)=>{return levelChangeType(v, tabItem.label)}">
                    <el-option
                      v-for="item in conditionType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="数值范围">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <!--                <el-button v-permisaction="['config:rewardExchangeStoreEdit:add']" type="primary" @click="beforeAddLevel(tabItem.label, index)">添加等级2</el-button>-->
              </el-form>
              <!--------  等级配置----->

              <!-- 二级等级-->
              <el-card v-if="tabItem.children.length > 0" class="box-card">
                <el-tabs v-model="levelActiveName2" tab-position="left" style="height: 100%;" @tab-click="handleClick">
                  <el-tab-pane v-for="(tabItem1,index) in tabItem.children" :key="index" :name="tabItem1.label" :label="getLabelName(tabItem1.label)">
                    <template #label>
                      <div>
                        {{ getLabelName(tabItem1.label) }} <i class="el-icon-circle-close" style="color:red" @click="delChildren(tabItem.label, index)" />
                      </div>
                    </template>
                    <el-form :inline="true">
                      <el-form-item label="选择类型">
                        <el-select v-model="tabItem1.type" style="width: 150px" placeholder="请选择" @change="(v)=>{return levelChangeType(v, tabItem.label,1,tabItem1.label,index)}">
                          <el-option
                            v-for="item in conditionType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="数值范围">
                        <el-input v-model.number="tabItem1.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem1.type,tabItem1.bak_min_level, tabItem1.bak_max_level,1,tabItem.label,tabItem1.label)}" />
                      </el-form-item>
                      <el-form-item label="-">
                        <el-input v-model.number="tabItem1.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem1.type,tabItem1.bak_min_level, tabItem1.bak_max_level,1,tabItem.label,tabItem1.label)}" />
                      </el-form-item>
                      <!--                      <el-button v-permisaction="['config:rewardExchangeStoreEdit:add']" type="primary" @click="beforeAddLevel(tabItem1.label, index)">添加等级2</el-button>-->
                    </el-form>

                    <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem1.label,tabItem.label, index)">+分组</el-button>
                    <el-form>
                      <el-row v-for="(scoreItem, scoreIndex) in tabItem1.data" :key="scoreIndex">
                        <el-card class="box-card" style="margin-top: 10px">
                          <div slot="header" class="clearfix" style="height: 60px;">
                            <el-form :inline="true">
                              <el-form-item label="选择分组">
                                <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name,1,index,scoreIndex)}">
                                  <el-option
                                    v-for="item in groups"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  />
                                </el-select>
                              </el-form-item>
                              <!--                              <el-button type="primary" @click="delGroup(tabItem.label,scoreIndex,1 )">删除</el-button>-->
                            </el-form>
                          </div>
                          <el-form>
                            <el-table :data="scoreItem.data[0].rewards.rewards" border stripe>
                              <el-table-column prop="stage" label="Id">
                                <template slot-scope="scope">
                                  <el-input v-model.number="scope.row.id" placeholder="阶段" />
                                </template>
                              </el-table-column>
                              <el-table-column prop="prop.type" label="道具ID">
                                <template slot-scope="scope">
                                  <el-select v-model.number="scope.row.prop.type" style="width: 100px;" placeholder="请选择" @change.native="typeChange">
                                    <el-option
                                      v-for="(item, index) in rewardType"
                                      :key="index"
                                      :label="item.label"
                                      :value="item.value"
                                    />
                                  </el-select>
                                </template>
                              </el-table-column>
                              <el-table-column prop="prop.num" label="物品数量">
                                <template slot-scope="scope">
                                  <el-input v-model.number="scope.row.prop.num" style="width: 80px;" placeholder="物品数量" />
                                </template>
                              </el-table-column>
                              <el-table-column prop="prop.skin" label="选择皮肤">
                                <template slot-scope="scope">
                                  <el-select v-if="scope.row.prop.type === 62 || beatsArr.includes(scope.row.prop.type)" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                                    <el-option
                                      v-for="item in chessId"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                      :disabled="item.disabled"
                                    />
                                  </el-select>

                                  <el-select v-if="scope.row.prop.type === 19" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                                    <el-option
                                      v-for="item in areaId"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    />
                                  </el-select>
                                  <el-select v-if="scope.row.prop.type === 23" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                                    <el-option
                                      v-for="item in avatar"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    />
                                  </el-select>
                                  <el-select v-if="activtyToTypeId.includes(scope.row.prop.type)" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                                    <el-option
                                      v-for="item in activtyList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id"
                                    />
                                  </el-select>
                                </template>
                              </el-table-column>
                              <el-table-column prop="prop.skin" label="取值范围" width="130px">
                                <template slot-scope="scope">
                                  <el-select v-model.number="scope.row.prop.rtype" :disabled="!goldCard.includes(scope.row.prop.type)" placeholder="请选择" style="width: 120px">
                                    <el-option
                                      v-for="item in selectType"
                                      :key="item.id"
                                      :label="item.title"
                                      :value="item.id"
                                    />
                                  </el-select>
                                </template>
                              </el-table-column>
                              <el-table-column prop="type" label="兑换币类型">
                                <template slot-scope="scope">
                                  <el-select v-model="scope.row.type" placeholder="请选择">
                                    <el-option
                                      v-for="item in exchangeType"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    />
                                  </el-select>
                                </template>
                              </el-table-column>
                              <el-table-column prop="num" label="兑换币数量">
                                <template slot-scope="scope">
                                  <el-input v-model.number="scope.row.num" placeholder="兑换币数量" />
                                </template>
                              </el-table-column>
                              <el-table-column prop="maxTimes" label="兑换次数">
                                <template slot-scope="scope">
                                  <el-input v-model.number="scope.row.maxTimes" placeholder="兑换次数" />
                                </template>
                              </el-table-column>
                              <el-table-column prop="v" label="展示权重">
                                <template slot-scope="scope">
                                  <el-input v-model.number="scope.row.v" placeholder="展示权重" />
                                </template>
                              </el-table-column>
                              <!--                              <el-table-column prop="time" label="刷新时间(h)">-->
                              <!--                                <template slot-scope="scope">-->
                              <!--                                  <el-input v-model.number="scope.row.time" placeholder="刷新时间" />-->
                              <!--                                </template>-->
                              <!--                              </el-table-column>-->
                              <el-table-column prop="status" label="状态">
                                <template slot-scope="scope">
                                  <el-select v-model="scope.row.status" placeholder="请选择">
                                    <el-option
                                      v-for="item in statusType"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    />
                                  </el-select>
                                </template>
                              </el-table-column>
                              <el-table-column>
                                <template slot-scope="scope">
                                  <el-button style="margin-top: 10px" type="danger" @click="delEvent2(tabItem.label,scoreIndex,scope.$index,1)">删除</el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                            <el-button style="margin-top: 10px" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name,scoreIndex,1, index)">+</el-button>
                            <el-button v-permisaction="['config:rewardExchangeStoreEdit:add']" :disabled="isOnline === 1" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
                            <el-button style="margin-top: 10px" type="danger" @click="delEvent(tabItem.label,scoreIndex,1,index)">删除</el-button>
                          </el-form>
                        </el-card>
                      </el-row>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>
              <!-- 二级等级-->
              </el-card>
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label,'')">+分组</el-button>
              <el-form>
                <el-row v-for="(scoreItem, scoreIndex) in tabItem.data" :key="scoreIndex">
                  <el-card class="box-card" style="margin-top: 10px">
                    <div slot="header" class="clearfix" style="height: 60px;">
                      <el-form :inline="true">
                        <el-form-item label="选择分组">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option
                              v-for="item in groups"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </div>
                    <el-form>
                      <el-table :data="scoreItem.data[0].rewards.rewards" border stripe>
                        <el-table-column prop="stage" label="Id">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.id" placeholder="阶段" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="stage" label="Id">
                          <template slot-scope="scope">
                            <Reward :value="scope.row.prop" limit-len="1" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="prop.type" label="道具ID">
                          <template slot-scope="scope">
                            <el-select v-model.number="scope.row.prop.type" style="width: 100px;" placeholder="请选择" @change="propChange">
                              <el-option
                                v-for="(item, index) in rewardType"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="prop.num" label="物品数量">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.prop.num" style="width: 80px;" placeholder="物品数量" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="prop.skin" label="选择皮肤">
                          <template slot-scope="scope">
                            <el-select v-if="[62,76,101,104].includes(scope.row.prop.type)" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                              <el-option
                                v-for="item in chessId"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :disabled="item.disabled"
                              />
                            </el-select>

                            <el-select v-if="scope.row.prop.type === 19" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                              <el-option
                                v-for="item in areaId"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                            <el-select v-if="scope.row.prop.type === 23" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                              <el-option
                                v-for="item in avatar"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                            <el-select v-if="[67,77,102,105].includes(scope.row.prop.type)" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                              <el-option
                                v-for="item in shield"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :disabled="item.disabled"
                              />
                            </el-select>
                            <el-select v-if="[68,78,103,106].includes(scope.row.prop.type)" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                              <el-option
                                v-for="item in sieve"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :disabled="item.disabled"
                              />
                            </el-select>
                            <el-select v-if="scope.row.prop.type === 71" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                              <el-option
                                v-for="item in blindBox"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                            <el-select v-if="scope.row.prop.type === 86" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                              <el-option
                                v-for="item in pinata"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                            <el-select v-if="activtyToTypeId.includes(scope.row.prop.type)" v-model.number="scope.row.prop.skin" placeholder="请选择" style="width: 120px">
                              <el-option
                                v-for="item in activtyList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="prop.skin" label="取值范围">
                          <template slot-scope="scope">
                            <el-select v-if="scope.row.prop.type===14" v-model.number="scope.row.prop.rtype" :disabled="!goldCard.includes(scope.row.prop.type)" placeholder="请选择" style="width: 120px">
                              <el-option
                                v-for="item in selectType"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id"
                              />
                            </el-select>
                            <el-select v-if="scope.row.prop.type === 13" v-model.number="scope.row.prop.rtype" placeholder="请选择" style="width: 120px">
                              <el-option
                                v-for="item in selectType2"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="prop.skin" label="是否限时">
                          <template slot-scope="scope">
                            <el-select v-if="beatsArr.includes(scope.row.prop.type)" v-model.number="scope.row.prop.is_ts" placeholder="请选择">
                              <el-option
                                v-for="item in tsType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="prop.ts" label="限时时间">
                          <template slot-scope="scope">
                            <el-input v-if="scope.row.prop.is_ts" v-model.number="scope.row.prop.ts" placeholder="限时时间" />
                            <span v-else>-</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="type" label="兑换币类型">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.type" placeholder="请选择">
                              <el-option
                                v-for="item in exchangeType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="num" label="兑换币数量">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.num" placeholder="兑换币数量" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="maxTimes" label="兑换次数">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.maxTimes" placeholder="兑换次数" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="v" label="展示权重">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.v" placeholder="展示权重" />
                          </template>
                        </el-table-column>
                        <!--                        <el-table-column prop="time" label="刷新时间(h)">-->
                        <!--                          <template slot-scope="scope">-->
                        <!--                            <el-input v-model.number="scope.row.time" placeholder="刷新时间" />-->
                        <!--                          </template>-->
                        <!--                        </el-table-column>-->
                        <el-table-column prop="status" label="状态">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.status" placeholder="请选择">
                              <el-option
                                v-for="item in statusType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column>
                          <template slot-scope="scope">
                            <el-button type="danger" @click="delEvent2(tabItem.label,scoreIndex,scope.$index,0)">删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-button style="margin-top: 10px" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name,scoreIndex,0)">+</el-button>
                      <el-button v-permisaction="['config:rewardExchangeStoreEdit:add']" :disabled="isOnline === 1" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
                      <el-button :disabled="isOnline === 1" style="margin-top: 10px" type="danger" @click="delEvent(tabItem.label,scoreIndex,0)">删除</el-button>
                    </el-form>
                  </el-card>
                </el-row>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getChessBoardType, getRewardType } from '@/api/config/slot'
import {
  exportActivtyRewardCfg, getActivtyAllList,
  getActivtyList,
  getActivtyRewardCfg, getActivityTypeToMap,
  getConditionTypesList,
  importActivtyRewardCfg,
  updateActivtyRewardCfg
} from '@/api/config/activity-cfg'
import { getSku } from '@/api/config/shop-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { getCacheConfig, getRewardListForType } from '@/utils'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getBuildBoxAllCfg } from '@/api/config/blind-box-cfg'
import { getAvatarCfgAll } from '@/api/config/avatar-cfg'
import Reward from '@/components/Reward/index.vue'
import { pinata } from '@/api/config/api'
export default {
  name: 'RewardExchangeStoreEdit',
  components: { Reward },
  data() {
    return {
      isOnline: 0,
      beatsArr: [76, 77, 78],
      skinId: [62, 19, 23, 67, 68],
      goldCard: [14, 13, 69, 70, 50, 49, 48],
      limitVipSkinId: [62, 67, 68], // vip 限制 棋子 野兽 盾牌
      chessId: [],
      areaId: [],
      avatar: [],
      blindBox: [],
      shield: [],
      sieve: [],
      ucType: 0,
      loading: false,
      exchangeType: [{ label: '绿钻', value: 1 }, { label: '野兽币', value: 2 }, { label: '广告', value: 4 }, { label: '广告-绿钻', value: 5 }],
      statusType: [{ label: '上架', value: 1 }, { label: '下架', value: 0 }],
      aid: 0,
      tabPane: [],
      shopSku: [],
      visibleArr: {},
      selectType2: [{
        'id': 1,
        'title': '随机金卡'
      }],
      selectType: [
        { 'id': 1, 'title': '只取数量' },
        { 'id': 2, 'title': '等级取值' }
      ],
      tsType: [
        { 'value': 1, 'label': '限时' },
        { 'value': 0, 'label': '不限时' }
      ],
      drawerAct: false,
      openPushType: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      extraData: {
        isShowSpine: 0,
        open: 0,
        ts: [
          { s: '', e: '' }
        ]
      },
      tabPaneTemp: {
        label: '',
        type: '',
        bak_type: '',
        min_level: 0,
        max_level: 0,
        bak_min_level: 0,
        bak_max_level: 0,
        children: [],
        data: []
      },
      drawer: {},
      direction: 'rtl',
      rewardType: [],
      chessBoardType: [],
      groups: [
        { label: '默认分组', value: 0 }
      ],
      conditionType: [],
      actType: '',
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0,
        type: 'level',
        parent: '',
        index: 0
      },
      scoreFormData: {
        group: [],
        parent: '',
        group_name: '',
        group_bak: [],
        level_name: '',
        index: 0,
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      levelActiveName2: '',
      copyFormData: {},
      formData: {},
      activtyToType: [],
      activtyToTypeId: [],
      activtyList: [],
      pinata: []
    }
  },
  created() {
    this.getBlindBox()
    this.getShieldsId()
    this.getSieveId()
    this.getChessId()
    this.getPinata()
    this.getAreaId()
    this.getAvatarCfg()
    this.getConditionTypeData()
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.typeChange('')
    this.getActivtyToType()
    this.getTables()
    this.getRewardTypeData(1)
    this.getChessBoardType()
    this.getGroup()
    // this.getAct()
  },
  methods: {
    beforeAddLevel(parent = '', index = -1) {
      this.dialogVisible = true
      this.levelFormData.parent = parent
      this.levelFormData.index = index
    },
    bugChange(v, levelName, scoreName, index) {
      if (v === 1) {
        this.formData[levelName][scoreName].data[0].rewards[index].sku = this.coinType[0].value
        this.formData[levelName][scoreName].data[0].rewards[index].price = this.shopSku[0].value
      } else {
        this.formData[levelName][scoreName].data[0].rewards[index].sku = this.shopSku[0].sku
        this.formData[levelName][scoreName].data[0].rewards[index].price = this.shopSku[0].value
      }
    },
    getAvatarCfg() {
      getAvatarCfgAll().then(res => {
        const data = res.data
        for (const i in data) {
          this.avatar.push({ label: data[i].name, value: parseInt(data[i].avatar_id) })
        }
      })
    },
    getAreaId() {
      getChestCfgAll().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.areaId.push({ 'label': res.data[i].name, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getBlindBox() {
      getBuildBoxAllCfg().then(res => {
        for (const i in res.data) {
          this.blindBox.push({ 'label': res.data[i].name, 'value': parseInt(res.data[i].id) })
        }
      })
    },
    getChessId() {
      getCacheConfig(getAnimalAllList, 'getAnimalAllList').then(res => { this.setConfig(this.chessId, res.data) })
    },
    getPinata() {
      getCacheConfig(pinata, 'pinata').then(res => {
        for (const i in res.data) {
          this.pinata.push({ label: res.data[i].name, value: parseInt(res.data[i].id) })
        }
      })
    },
    getShieldsId() {
      getCacheConfig(getShieldsAllList, 'getShieldsAllList').then(res => { this.setConfig(this.shield, res.data) })
    },
    getSieveId() {
      getCacheConfig(getSieveAllList, 'getDiceAllList').then(res => { this.setConfig(this.sieve, res.data) })
    },
    setConfig(conf, data) {
      for (const i in data) {
        const list = { label: data[i].lang_key, value: parseInt(data[i].id), disabled: data[i].vip === 1 }
        if (data[i].vip === 1) {
          conf.push(list)
        } else {
          conf.unshift(list)
        }
      }
    },
    getSkuList() {
      getSku({ type: 3 }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          res.data.forEach((item) => {
            this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    priceChange(v, levelName, scoreName, index) {
      let sku = ''
      this.shopSku.forEach((item) => {
        if (item.value === v) {
          sku = item.sku
        }
      })
      this.formData[levelName][scoreName].data[0].rewards[index].sku = sku
    },
    getConditionTypeData() {
      getConditionTypesList({ data: 1 }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.conditionType.push({ 'label': res.data[i], 'value': i })
          }
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs['upload'].clearFiles()
      importActivtyRewardCfg({ type: this.actType, name: this.aid, data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportActivtyRewardCfg({ id: this.aid, type: this.actType }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    onSubmit() {
      const postFormDataCondition = {}
      const _postData = []
      let levelIndex = 0
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        levelIndex++
        let childrenIndex = 0
        for (const i2 in tabPane.children) {
          childrenIndex++
          const childrenData = tabPane.children[i2]
          const [pType, pMinLevel, pMaxLevel] = tabPane.label.split('-')
          const parentCond = {
            start: parseInt(pMinLevel),
            end: parseInt(pMaxLevel),
            shushu: [],
            type: pType
          }
          const [type, minLevel, maxLevel] = childrenData.label.split('-')
          let groupIndex = 0
          for (const i3 in childrenData.data) {
            const data = childrenData.data[i3]
            if (data.data.length <= 0) {
              continue
            }
            groupIndex++
            for (const i4 in data.data) {
              const _rewards = data.data[i4]
              for (const i5 in _rewards.rewards) {
                const _reward = _rewards.rewards[i5]
                if (_reward.stage <= 0) {
                  this.msgError('阶段不能是0')
                  return
                }

                if (_reward.lv <= 0) {
                  this.msgError('等级不能是0')
                  return
                }
              }
            }

            const condition = {
              start: parseInt(minLevel),
              end: parseInt(maxLevel),
              shushu: [],
              type: type
            }

            const condition1 = {
              start: 0,
              end: 0,
              shushu: data.group,
              type: 'shushu'
            }

            const key = `${levelIndex}-${childrenIndex}-${groupIndex}`
            postFormDataCondition[key] = [parentCond, condition, condition1]

            const _data = data.data[0]
            _data.aid = this.aid
            _data.stage = key
            _postData.push(_data)
          }
        }

        for (const i6 in tabPane.data) {
          childrenIndex++
          const data1 = tabPane.data[i6]
          for (const i7 in data1.data) {
            const _rewards = data1.data[i7]
            for (const i5 in _rewards.rewards) {
              const _reward = _rewards.rewards[i5]
              for (const k in _reward) {
                const stage = _reward[k]
                if (stage.id <= 0) {
                  this.msgError('ID不能是0')
                  return
                }

                if (stage.type === 2) {
                  _rewards.rewards[i5][k].num *= 10000
                }

                if (stage.prop.type === 65) {
                  _rewards.rewards[i5][k].prop.num *= 10000
                }
              }
              data1.data[i7] = _rewards
            }
          }

          const [type, minLevel, maxLevel] = tabPane.label.split('-')
          const condition = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            shushu: [],
            type: type
          }

          const condition1 = {
            start: 0,
            end: 0,
            shushu: data1.group,
            type: 'shushu'
          }

          const key = levelIndex + '-' + childrenIndex
          postFormDataCondition[key] = [condition, condition1]

          const _data = data1.data[0]
          _data.aid = this.aid
          _data.stage = key
          _postData.push(_data)
        }
      }
      console.log('tabPane', this.tabPane)
      const postCondition = JSON.stringify({ aid: this.aid, condition: postFormDataCondition })
      const newPostData = JSON.parse(JSON.stringify(_postData))
      console.log('data', newPostData)
      for (const i in newPostData) {
        const val = newPostData[i]
        newPostData[i].rewards = val.rewards.rewards
      }

      console.log('data1', newPostData)
      const postFormData = JSON.stringify(newPostData)
      console.log('postCondition', postCondition)
      console.log('_postData', postFormData)
      updateActivtyRewardCfg({ id: this.aid, type: this.actType, name: postCondition, data: postFormData }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    createParentTabPent(val) {
      const parentTemp = {
        label: '',
        type: '',
        bak_type: '',
        min_level: 0,
        max_level: 0,
        bak_min_level: 0,
        bak_max_level: 0,
        children: [],
        data: []
      }
      parentTemp.label = `${val.type}-${val.start}-${val.end}`
      parentTemp.type = val.type
      parentTemp.bak_type = val.type
      parentTemp.min_level = val.start
      parentTemp.max_level = val.end
      parentTemp.bak_min_level = val.start
      parentTemp.bak_max_level = val.end
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        if (tabPane.label === parentTemp.label) {
          return
        }
      }
      this.tabPane.push(parentTemp)
    },
    createChildrenTabPent(label, children, group) {
      const tabPane = this.getTabPane(label)
      for (const i in tabPane.children) {
        const val = tabPane.children[i]
        if (val.label === children.label) {
          // 分组是否存在
          for (const i2 in val.data) {
            const g = val.data[i2]
            if (g.group_name === group.group_name) {
              return
            }
          }
          val.data.push(group)
          tabPane.children[i] = val
          return
        }
      }
      children.data.push(group)
      tabPane.children.push(children)
    },
    createTabPen(tabPane, obj) {
      for (const i in tabPane.data) {
        const val = tabPane.data[i]
        if (val.group_name === obj.group_name) {
          return
        }
      }
      tabPane.data.push(obj)
    },
    getTables() {
      getActivtyRewardCfg({ id: this.aid }).then(res => {
        this.tabPane = []
        const cond = res.data.cond.condition
        const data = res.data.data
        for (const i in cond) {
          const condLen = cond[i].length
          const val = cond[i][0]
          const val1 = cond[i][1]
          this.createParentTabPent(val)
          let id = 0
          let reward = [{ aid: 0, stage: [], rewards: [] }]
          const parentLabel = `${val.type}-${val.start}-${val.end}`
          const tabPane = this.getTabPane(parentLabel)
          this.levelActiveName = parentLabel
          for (const k in data) {
            const _data = data[k]
            if (_data.stage === i) {
              for (const i1 in _data.rewards.rewards) {
                const reward = _data.rewards.rewards[i1]
                if (reward.type === 2) {
                  _data.rewards.rewards[i1].num /= 10000
                }
                if (reward.prop.type === 65) {
                  _data.rewards.rewards[i1].prop.num /= 10000
                }
              }
              reward = [_data]
              id = _data.id
              break
            }
          }
          if (condLen > 2) {
            const val2 = cond[i][2]
            const parentTemp = Object.assign({}, this.tabPaneTemp)
            parentTemp.bak_min_level = val1.start
            parentTemp.bak_max_level = val1.end
            parentTemp.min_level = val1.start
            parentTemp.max_level = val1.end
            parentTemp.type = val1.type
            parentTemp.bak_type = val1.type
            parentTemp.label = `${val1.type}-${val1.start}-${val1.end}`
            parentTemp.data = []
            parentTemp.children = []
            const group = {
              'group': val2.shushu,
              'group_name': val2.shushu.join('-'),
              'group_bak': val2.shushu,
              'data': reward,
              id: id
            }
            // parentTemp.data.push(group)
            this.createChildrenTabPent(parentLabel, parentTemp, group)
            this.levelActiveName2 = parentTemp.label
          } else {
            this.createTabPen(tabPane, {
              'group': val1.shushu,
              'group_name': val1.shushu.join('-'),
              'group_bak': val1.shushu,
              'data': reward,
              id: id
            })
          }
        }

        console.log('this.tabPane', this.tabPane)
      })
    },
    levelChangeType(newVal, levelName, isParent = 0, levelName2) {
      // 是否存在相同类型
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === levelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })

      if (fileIndex === -1) {
        this.msgError('修改失败')
        return
      }

      const oldTabPane = this.tabPane[fileIndex]
      let newLabelName = newVal + '-' + oldTabPane.min_level + '-' + oldTabPane.max_level
      if (!isParent) {
        for (const i in this.tabPane) {
          const tabPane = this.tabPane[i]
          if (tabPane.label === newLabelName) {
            this.msgError('当前类型配置已经存在')
            return
          }
        }
        oldTabPane.label = newLabelName
        this.tabPane[fileIndex] = oldTabPane
        this.levelActiveName = newLabelName
      } else {
        if (oldTabPane.label === newLabelName) {
          this.msgError('当前类型配置不能与父类型一致')
          return
        }
        let childrenTabPane = []
        let childrenTabIndex = 0
        for (const i in oldTabPane.children) {
          const val = oldTabPane.children[i]
          if (val.label === newLabelName) {
            this.msgError('当前类型配置已经存在')
            return
          }
        }

        for (const i in oldTabPane.children) {
          const val = oldTabPane.children[i]
          if (val.label === levelName2) {
            childrenTabPane = val
            childrenTabIndex = i
            break
          }
        }
        newLabelName = newVal + '-' + childrenTabPane.min_level + '-' + childrenTabPane.max_level
        childrenTabPane.label = newLabelName
        this.tabPane[fileIndex].children[childrenTabIndex] = childrenTabPane
        this.levelActiveName2 = newLabelName
      }
    },
    levelChange(newVal, isMin, type, bakMin, bakMax, isParent = 0, parentLabel, levelName2) {
      newVal = parseInt(newVal)
      let oldLevelName = type + '-' + bakMin + '-' + bakMax
      if (isParent) {
        oldLevelName = parentLabel
      }
      let newLevelName = ''
      if (isMin) {
        newLevelName = type + '-' + newVal + '-' + bakMax
      } else {
        newLevelName = type + '-' + bakMin + '-' + newVal
      }
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      console.log(fileIndex)
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        let childrenTabPane = []
        let childrenTabIndex = 0
        if (isParent) {
          for (const i in oldTab.children) {
            const val = oldTab.children[i]
            if (val.label === levelName2) {
              childrenTabPane = val
              childrenTabIndex = i
              break
            }
          }

          if (isMin) {
            childrenTabPane['bak_min_level'] = newVal
            childrenTabPane['min_level'] = newVal
          } else {
            childrenTabPane['bak_max_level'] = newVal
            childrenTabPane['max_level'] = newVal
          }
          childrenTabPane['label'] = newLevelName
          this.tabPane[fileIndex].children[childrenTabIndex] = childrenTabPane
          this.levelActiveName2 = newLevelName
        } else {
          oldTab['label'] = newLevelName
          if (isMin) {
            oldTab['bak_min_level'] = newVal
            oldTab['min_level'] = newVal
          } else {
            oldTab['bak_max_level'] = newVal
            oldTab['max_level'] = newVal
          }
          this.tabPane[fileIndex] = oldTab
          this.levelActiveName = newLevelName
        }
      }
    },
    addEventReward(levelName, scoreName, index, i) {
      console.log(this.formData[levelName][scoreName].data[index].config[i])
      let propsId = 14
      if (this.formData[levelName][scoreName].data[index].config[i].type === 3) {
        propsId = 1
        if (this.formData[levelName][scoreName].data[index].config[i].reward.length >= 1) {
          return
        }
      }
      this.formData[levelName][scoreName].data[index].config[i].reward.push({
        propsId: propsId,
        skin: 0,
        num: 0,
        rtype: 2
      })
    },
    addEvent1(levelName, scoreName, index) {
      this.formData[levelName][scoreName].data[index].config.push({
        aid: 1,
        reward: [{
          state: 1,
          stepnum: 1,
          prize: [
            {
              id: 1,
              num: 1,
              skin: 0,
              rtype: 2,
              type: 2,
              is_ts: 0
            }],
          progressBarId: 1,
          stageSpins: 1
        }],
        stage: []
      })
    },
    delEvent1(levelName, index, scoreIndex, isParent = false) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('添加失败,未找到元素')
        return
      }

      tabPane.data[scoreIndex].data[0].rewards = tabPane.data[scoreIndex].data[0].rewards.filter((item, key) => {
        return index !== key
      })

      let count = 0
      tabPane.data[scoreIndex].data[0].rewards.forEach((res, index) => {
        count++
        tabPane.data[scoreIndex].data[0].rewards[index].stage = count
      })
    },
    addCond(levelName, scoreName, scoreIndex, isParent = 0, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('添加失败,未找到元素')
        return
      }

      console.log('parentIndex', parentIndex)
      // console.log('cond', tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.cond)
      if (isParent) {
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.cond.push({
          ts: 0,
          stage: 0,
          minPercent: 0,
          maxPercent: 0,
          coefficient: 0
        })
      } else {
        tabPane.data[scoreIndex].data[0].rewards.cond.push({
          ts: 0,
          stage: 0,
          minPercent: 0,
          maxPercent: 0,
          coefficient: 0
        })
      }
    },
    delCond(levelName, scoreIndex, index, isParent = 0, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('删除失败,未找到元素')
        return
      }

      if (isParent) {
        console.log('cond', tabPane.children[scoreIndex].data[index].data[0].rewards.cond)
        tabPane.children[scoreIndex].data[index].data[0].rewards.cond = tabPane.children[scoreIndex].data[index].data[0].rewards.cond.filter((item, idx) => {
          return index !== idx
        })
      } else {
        tabPane.data[scoreIndex].data[0].rewards.cond = tabPane.data[scoreIndex].data[0].rewards.cond.filter((item, idx) => {
          return idx !== index
        })
      }
    },
    delEvent2(levelName, scoreIndex, index, isParent = 0, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('删除失败,未找到元素')
        return
      }

      if (isParent) {
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards = tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards.filter((item, idx) => {
          return index !== idx
        })
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards.forEach((item, idx) => {
          tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards[idx].id = idx + 1
        })
      } else {
        tabPane.data[scoreIndex].data[0].rewards.rewards = tabPane.data[scoreIndex].data[0].rewards.rewards.filter((item, idx) => {
          return idx !== index
        })
        tabPane.data[scoreIndex].data[0].rewards.rewards.forEach((item, idx) => {
          tabPane.data[scoreIndex].data[0].rewards.rewards[idx].id = idx + 1
        })
      }
    },
    addEvent(levelName, scoreName, scoreIndex, isParent = 0, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)

      if (!tabPane) {
        this.msgError('添加失败,未找到元素')
        return
      }

      if (isParent) {
        const len = tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards.length
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards.push({
          id: len + 1,
          prop: {
            id: 0,
            num: 1,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          },
          type: 1,
          num: 1,
          maxTimes: 1,
          v: 1,
          time: 1,
          status: 1
        })
      } else {
        const len = tabPane.data[scoreIndex].data[0].rewards.rewards.length
        tabPane.data[scoreIndex].data[0].rewards.rewards.push({
          id: len + 1,
          prop: {
            id: 0,
            num: 1,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          },
          type: 1,
          num: 1,
          maxTimes: 1,
          v: 1,
          time: 1,
          status: 1
        })
      }
    },
    delEvent(levelName, scoreIndex, isParent = 0, index = 0) {
      const tabPane = this.getTabPane(levelName)
      if (isParent) {
        tabPane.children[index].data = tabPane.children[index].data.filter((item, idx) => {
          return idx !== scoreIndex
        })
      } else {
        tabPane.data = tabPane.data.filter((item, index) => {
          return index !== scoreIndex
        })
      }

      // if (isParent) {
      //   const tabPane = this.getTabPane(levelName)
      //   tabPane.children[index].data = tabPane.children[index].data.filter((res, key) => {
      //     return scoreIndex !== key
      //   })
      // } else {
      //   const tabPane = this.getTabPane(levelName)
      //   tabPane.data[index].data = tabPane.data[index].data.filter((res, key) => {
      //     return scoreIndex !== key
      //   })
      //   if (id > 0) {
      //     this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消',
      //       type: 'warning'
      //     }).then(() => {
      //       delActivtyRewardCfg({ id: id }).then(res => {
      //         if (res.code === 200) {
      //           this.onSubmit()
      //         // this.getTables()
      //         } else {
      //         // this.msgError(res.msg)
      //         }
      //       })
      //     }).catch(() => {
      //       this.$message({
      //         type: 'info',
      //         message: '已取消删除'
      //       })
      //     })
      //   }
      // }
    },
    addScoreEvent(levelName, parent, index) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.parent = parent
      this.scoreFormData.index = index
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      const parent = score.parent
      const index = score.index
      console.log('parent', parent)
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      let label = score.level_name
      if (parent !== '') {
        label = parent
      }
      let tabPaneEdit = []
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        if (tabPane.label === label) {
          tabPaneEdit = tabPane
          break
        }
      }

      if (!tabPaneEdit) {
        this.msgError('添加失败,未找到元素')
        return
      }

      if (parent !== '') {
        for (const i in tabPaneEdit.children[index].data) {
          const g = tabPaneEdit.children[index].data[i]
          if (g.group_name === scoreTag) {
            this.msgError('添加失败,当前分组已经存在')
            return
          }
        }
        tabPaneEdit.children[index].data.push({
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': [{ aid: 0, stage: [], rewards: { rewards: [] }}]
        })
      } else {
        for (const i in tabPaneEdit.data) {
          const g = tabPaneEdit.data[i]
          if (g.group_name === scoreTag) {
            this.msgError('添加失败,当前分组已经存在')
            return
          }
        }
        tabPaneEdit.data.push({
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': [{ aid: 0, stage: [], rewards: { rewards: [] }}]
        })
      }

      // 添加第一个元素
      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
    },
    addLevel() {
      const parent = this.levelFormData.parent
      const index = this.levelFormData.index
      console.log('添加等级', 'label', parent, 'index', index)
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.type + '-' + this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (parent !== '') {
        if (this.tabPane[index].label === levelName) {
          this.msgError('父级类型不能和当前所有类型相同')
          return
        }
        for (const i in this.tabPane[index].children) {
          const tabPane = this.tabPane[index].children[i]
          if (tabPane.type === this.levelFormData.type && tabPane.label === levelName) {
            this.msgError('当前配置已经存在')
            return
          }
        }
      } else {
        for (const i in this.tabPane) {
          const tabPane = this.tabPane[i]
          if (tabPane.type === this.levelFormData.type && tabPane.label === levelName) {
            this.msgError('当前配置已经存在')
            return
          }
        }
      }

      const tabPane = {
        label: levelName,
        type: this.levelFormData.type,
        bak_type: this.levelFormData.type,
        min_level: this.levelFormData.min_level,
        max_level: this.levelFormData.max_level,
        bak_min_level: this.levelFormData.min_level,
        bak_max_level: this.levelFormData.max_level,
        children: [],
        data: []
      }

      if (index > -1) {
        this.tabPane[index].children.push(tabPane)
        this.levelActiveName2 = levelName
      } else {
        this.tabPane.push(tabPane)
        this.levelActiveName = levelName
      }
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData(uc_type) {
      getRewardType({ data: uc_type }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(levelName, index, scoreIndex, isParent = false, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('奖励添加失败,未找到元素')
        return
      }
      console.log('index', index)
      console.log('scoreIndex', scoreIndex)
      if (isParent) {
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards[index].prize.push(
          {
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          }
        )
      } else {
        console.log('tabPane', tabPane.data[scoreIndex].data[0].rewards, index)
        tabPane.data[scoreIndex].data[0].rewards.rewards[index].prize.push(
          {
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          }
        )
      }

      this.saveTabPane(levelName, tabPane)
    },
    delReward(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].reward = this.formData[levelName][groupName].data[index].reward.filter((item, key) => {
        return key !== i
      })
    },
    groupChange(v, levelName, oldGroupName, isParent = false, index, scoreIndex) {
      v = v.sort()
      const newGroupName = v.join('-')
      // oldData.group = v
      // oldData.group_bak = v
      // oldData.group_name = newGroupName
      const tabPane = this.getTabPane(levelName)
      if (isParent) {
        tabPane.children[index].data[scoreIndex].group = v
        tabPane.children[index].data[scoreIndex].group_name = newGroupName
        tabPane.children[index].data[scoreIndex].group_bak = v
      } else {
        tabPane.data[0].group = v
        tabPane.data[0].group_name = newGroupName
        tabPane.data[0].group_bak = v
      }
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessBoardType.push({ 'title': res.data[i], 'id': parseInt(i) })
          }
        }
      })
    },
    removeReward(levelName, index, scoreIndex, i, isParent = false, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('奖励添加失败,未找到元素')
        return
      }
      if (isParent) {
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards[index].prize = tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards[index].prize.filter((item, key) => {
          return i !== key
        })
      } else {
        tabPane.data[scoreIndex].data[0].rewards.rewards[index].prize = tabPane.data[scoreIndex].data[0].rewards.rewards[index].prize.filter((item, key) => {
          return i !== key
        })

        this.saveTabPane(levelName, tabPane)
      }
    }, getLabelName(label) {
      const arr = label.split('-')
      let typeName = ''
      this.conditionType.forEach((item) => {
        if (item.value === arr[0]) {
          typeName = item.label
        }
      })
      return typeName + '-Lv:' + arr[1] + '-' + arr[2]
    }, mtTypeChange(v, levelName, groupName, index) {
      this.formData[levelName][groupName].data[0].rewards[index].sku = ''
    }, getRewardList(prize, type) {
      return getRewardListForType(prize, this.rewardType, type)
    },
    checkFormData(label) {
      let count = 0
      for (const i in this.formData[label]) {
        const val = this.formData[label][i]
        count += val.data[0].rewards.length
      }

      if (count > 0) {
        return true
      }

      return false
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTabPane(levelName) {
      let tabPane = []
      for (const i in this.tabPane) {
        const val = this.tabPane[i]
        if (val.label === levelName) {
          tabPane = val
          break
        }
      }
      return tabPane
    },
    saveTabPane(levelName, tabPane) {
      for (const i in this.tabPane) {
        const val = this.tabPane[i]
        if (val.label === levelName) {
          this.tabPane[i] = tabPane
          break
        }
      }
    },
    delChildren(levelName, index) {
      const tabPane = this.getTabPane(levelName)
      this.$confirm('您确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tabPane.children = tabPane.children.filter((res, key) => {
          return key !== index
        })
      })
    },
    getAct() {
      getActivtyList({ id: this.aid }).then(res => {
        console.log(res)
        if (res.code === 200) {
          const extraData = res.data.list[0].extraData
          const ts = []
          for (const i in extraData.ts) {
            const val = extraData.ts[i]
            ts.push(val)
          }

          this.extraData.isShowSpine = extraData.isShowSpine
          this.extraData.open = extraData.open
          this.extraData.ts = ts
        } else {
          this.msgError('活动获取失败')
        }
      })
    },
    delGroup(labelName, scoreIndex, isChildren) {
      const tabPane = this.getTabPane(labelName)
      // console.log('labelName', labelName)
      // console.log('tabPane', tabPane)
      // console.log('tabPane.children', tabPane.children)
      delete tabPane.children[scoreIndex]
      if (isChildren) {
        console.log('delete', labelName, scoreIndex, tabPane.children[scoreIndex])
      }
    },
    typeChange(v) {
      console.log('v------------', v)
      // if (this.activtyToTypeId.includes(v)) {
      // if (v === 13) {
      //
      // }
      let typ = ''
      if (v) {
        typ = this.activtyToType[v]
      }
      getActivtyAllList({ type: typ }).then(res => {
        if (res.code === 200) {
          this.activtyList = res.data
        }
      })
    },
    getActivtyToType() {
      getActivityTypeToMap().then(res => {
        if (res.code === 200) {
          this.activtyToType = res.data
          for (const i in res.data) {
            this.activtyToTypeId.push(parseInt(i))
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    propChange() {

    }
  }
}
</script>

<style scoped>
</style>
